"use client"

import { useState } from "react"
import PropTypes from "prop-types"
import Counter from "./components/counter"


const ToolContainer = ({ settingsContainer, processContainer }) => {
  const [step, setStep] = useState(0)
  const [player, setPlayer] = useState(null);

  const doIt = () => {
    setStep(2)
  }

  const start = () => {
    const p = new Audio();
    p.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA";
    p.play().then(() => {
        p.pause();
    });
    setPlayer(p);
    setStep(1)
  }

  const finish = () => {
    setStep(0)
  }

  if (step === 0) {
    return settingsContainer(start)
  } else if (step === 1) {
    return <Counter onFinish={doIt} />
  } else {
    return processContainer(finish, start, player)
  }
}

ToolContainer.propTypes = {
  settingsContainer: PropTypes.func.isRequired,
  processContainer: PropTypes.func.isRequired,
}

export default ToolContainer
